import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CURRENT_PAGE_ACTION_TYPE = createNamedActions('currentPage', {
  SET_PAGE_CODE: 'SET_PAGE_CODE',
});

export const setCurrentPageCode = pageCode => dispatch => {
  return dispatch({
    type: CURRENT_PAGE_ACTION_TYPE.SET_PAGE_CODE,
    payload: pageCode,
  });
};
